import { useEffect, useState } from "react";
import { shouldBlockTabletPortrait } from "./tablet-orientation-policy";

function currentBlocked() {
  if (typeof window === "undefined") return false;
  const portrait = window.matchMedia("(orientation: portrait)");
  const orientation = window.screen.orientation;
  const legacyOrientation = (window as Window & { orientation?: number }).orientation;
  return shouldBlockTabletPortrait({
    coarsePointer: window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    orientationType: orientation?.type ?? null,
    orientationAngle: typeof legacyOrientation === "number" ? legacyOrientation : null,
    portraitMedia: portrait.matches,
  });
}

export function useTabletPortraitGuard() {
  const [blocked, setBlocked] = useState(currentBlocked);
  useEffect(() => {
    const portrait = window.matchMedia("(orientation: portrait)");
    const update = () => setBlocked(currentBlocked());
    update();
    portrait.addEventListener("change", update);
    window.screen.orientation?.addEventListener("change", update);
    window.addEventListener("orientationchange", update);
    return () => {
      portrait.removeEventListener("change", update);
      window.screen.orientation?.removeEventListener("change", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);
  return blocked;
}
